import { StyleSheet, View, Pressable } from 'react-native';
import TextLato from '../text/text-lato/TextLato';
import { brand, neutrals } from 'src/theme/colors';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
interface MultiplePurchaseOptionProps {
  label: string;
  discount: number;
  onPress: () => void;
}

export const MultiplePurchaseOption = ({ label, discount, onPress }: MultiplePurchaseOptionProps) => {
  return (
    <Pressable
      style={{ flex: 1 }}
      onPress={onPress}
      accessible={true}
      accessibilityLabel={label}
      accessibilityRole="button"
    >
      <View style={style.option}>
        <View style={style.textContainer}>
          <TextLato style={style.text}>{label}</TextLato>
          {!!discount && <TextLato style={[style.text, style.discount]}>{`-${discount}%`}</TextLato>}
        </View>
        <View style={style.icon}>
          <Icon name={ICON_NAMES.ArrowRight1} color={brand.main.water} />
        </View>
      </View>
    </Pressable>
  );
};

const style = StyleSheet.create({
  option: {
    flexDirection: 'row',
    backgroundColor: neutrals.coldGrays.ice,
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },
  textContainer: {
    flexDirection: 'row',
    gap: 8,
  },
  text: {
    fontSize: 16,
    lineHeight: 22,
    fontWeight: 700,
  },
  discount: {
    color: '#eb5d0b',
  },
  icon: {
    width: 13,
    height: 13,
  },
});
